import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Form, Message, Segment, Header } from 'semantic-ui-react'
import { connect } from 'react-redux'

import { logIn } from '../actions/authActions'

const Wrapper = styled.div`
    max-width: 400px;
    margin: 0 auto;
    margin-top: 20px;
    padding: 10px;
`

const PanelTitle = styled(Segment) `
    border-color: transparent !important;
`

class LoginPanel extends Component {
    state = {
        userValue: '',
        passValue: '',
        error: '',
        loading: false
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const user = this.state.userValue
        const pass = this.state.passValue
        if (pass === '' || user === '') return

        this.setState({ loading: true })
        this.props.logIn(user, pass)
            .catch(err => {
                this.setState({ loading: false, error: err.message })
            })
    }

    render() {
        const { title } = this.props
        const { userValue, passValue, error, loading } = this.state
        return (
            <Wrapper>

                <PanelTitle color="blue" inverted attached="top">
                    <Header textAlign="center">{title}</Header>
                </PanelTitle>

                <Form error={!!error} onSubmit={this.handleSubmit}>

                    <Segment attached="bottom">

                        <Form.Input
                            label="Käyttäjä"
                            name="userValue"
                            value={userValue}
                            onChange={this.handleChange}
                        />

                        <Form.Input
                            label="Salasana"
                            type="password"
                            name="passValue"
                            value={passValue}
                            onChange={this.handleChange}
                        />

                        <Message
                            error
                            content={error}
                        />

                        <Button type="submit" disabled={loading} fluid positive>Kirjaudu</Button>

                    </Segment>

                </Form>

            </Wrapper>
        )
    }
}

const mapDtoP = dispatch => {
    return {
        logIn: (user, pass) => dispatch(logIn(user, pass))
    }
}

export default connect(null, mapDtoP)(LoginPanel)
export { LoginPanel }


// WEBPACK FOOTER //
// ./src/Admin/LoginPanel.js